export const selectAuth = (state:any) => state.auth;
